import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

import SetAdvisor from "data/advisor/actions";
import useRedirect from "data/hub/hooks";
import { EditAdvisor } from "data/libs/advisor";

import { useAsyncCall } from "hooks";
import { SetAlert } from "components/Alerts/actions";

import { useAddUser, useCurrentUser, useHub, useSetHub } from ".";

const useStyles = makeStyles({
  addUserContainer: {
    "&": {
      border: "1px solid #C9C9C9",
      width: "100%",
      maxWidth: "1100px",
      display: "flex",
      flexDirection: "column",
      minWidth: "1051px",
    },
    "& .add-user-header": {
      padding: "40px 40px 0px 40px",
      fontSize: "1.6em",
      fontWeight: "bold",
      lineHeight: "1.5em",
    },
    "& .add-user-body": {
      padding: "0px 40px 40px 40px",
    },
    "& .add-user-footer": {
      padding: "20px 40px 20px 40px",
      display: "flex",
      justifyContent: "flex-end",
      gap: "1em",
      borderTop: "1px solid #C9C9C9",
    },
  },
  skipButton: {
    "&": {
      color: "#4183C4",
      background: "transparent",
      border: "none",
      cursor: "pointer",
      padding: "0",
      fontFamily: "Helvetica Neue",
      fontWeight: "bold",
      fontSize: "110%",
    },
  },
});

function useAddUserStep() {
  const classes = useStyles();
  const user = useCurrentUser();
  const dispatch = useDispatch();
  const hub = useHub();
  const setHub = useSetHub();
  const [call, isCompletingSetup] = useAsyncCall();
  const redirect = useRedirect();

  const onCompleteCallback = useCallback(() => {
    return call(() => {
      return EditAdvisor(user.id, { setupComplete: true })
        .then((u) => {
          dispatch(SetAdvisor(u));
          redirect("welcome/form");
        })
        .catch((err) => {
          console.error("Failed to set setupComplete", err);

          dispatch(
            SetAlert({
              type: "error",
              text: "Failed to continue the onboarding process, please retry or contact support for assistance.",
            })
          );
        });
    });
  }, [call, dispatch, user.id, redirect]);

  const addUserArgs = useAddUser(
    [],
    onCompleteCallback,
    onCompleteCallback,
    false,
    true
  );

  useEffect(() => {
    if (user && !hub) setHub(user.hubs[0]);
  }, [user, hub, setHub]);

  return {
    classes: classes,
    isCompletingSetup: isCompletingSetup,
    initializing: user && !hub,
    ...addUserArgs,
  };
}

export default useAddUserStep;
